//@flow

import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import {ContinueLink, HiddenBruImage} from "@/components";
import PlusIcon from "@/images/Plus.inline.svg";
import {useCurrentSrcChangeCallback} from "@/utils";

type Props = {
    title: string,
    content: string,
    image: ImageSharp,
    link: Link,
};

const LandingHighlight = (props: Props): React$Element<"a"> | React$Element<"div"> => {
    const [style, setStyle] = useState<any>({});

    const highlight = (
        <div className="landing-highlight mb-2 hover-zoom-visual">
            <div
                className="visual h-100 w-100 left top position-absolute darkness darkness-xl"
                style={style}
            >
                <HiddenBruImage
                    onCurrentSrcChange={useCurrentSrcChangeCallback(setStyle)}
                    image={props.image}
                />
            </div>

            <div className="container content-wrap py-4 py-lg-5">
                <Row>
                    <Col>
                        <Row className={"content align-content-between"}>
                            <Col
                                xl={{ span: 6 }}
                                lg={{ span: 8 }}
                                className={"deeper-col order-2 order-lg-1"}
                            >
                                <h2 className="fs-5 mb-4">{props.title}</h2>

                                <h3 className="fs-5 mb-4">{props.content}</h3>

                                <div>
                                    <ContinueLink variant="light">
                                        {props.link.text}
                                    </ContinueLink>
                                </div>
                            </Col>

                            <Col
                                xl={{ span: 6 }}
                                lg={{ span: 4 }}
                                className={"deeper-col order-1 order-lg-2"}
                            >
                                <div className="float-right fs-5">
                                    <PlusIcon className="icon-plus" />
                                    Highlights
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    );

    if (props.link.path) {
        return (
            <a
                href={props.link.path}
                target={props.link.target}
                className={"continue-link-hover-parent"}
            >
                {highlight}
            </a>
        );
    }

    return highlight;
};

export default LandingHighlight;
